import React, { useEffect, useRef, useState } from 'react';
import { Check, X } from 'lucide-react';
import { useLanguage } from '../i18n';

const RsvpSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const phone = "393341998209";
  const waLink = (messageKey) =>
    `https://wa.me/${phone}?text=${encodeURIComponent(t(messageKey))}`;

  return (
    <section
      ref={sectionRef}
      className="py-28 md:py-40 bg-regency relative overflow-hidden"
      id="rsvp"
    >
      {/* Decorative background */}
      <div className="absolute inset-0 damask-pattern opacity-35" />
      <div className="absolute top-0 right-0 w-72 h-72 bg-lavender/8 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-blush/40 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        <div className={`text-center max-w-2xl mx-auto transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <p className="font-display text-sm uppercase tracking-[0.5em] text-gold mb-5">
            {t('rsvp.eyebrow')}
          </p>
          <h2 className="font-script text-5xl md:text-6xl lg:text-7xl text-lavender mb-8">
            {t('rsvp.title')}
          </h2>
          <p className="font-elegant text-xl md:text-2xl text-muted-foreground italic mb-16">
            {t('rsvp.subtitle')}
          </p>

          {/* RSVP buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a
              href={waLink('rsvp.msgYes')}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative inline-flex items-center gap-3 px-12 py-5 rounded-full bg-lavender text-white overflow-hidden shadow-elegant transition-transform duration-300 hover:-translate-y-1"
              data-testid="rsvp-yes-button"
            >
              <Check className="w-5 h-5" />
              <span className="font-display text-sm uppercase tracking-[0.25em]">{t('rsvp.yes')}</span>
            </a>
            <a
              href={waLink('rsvp.msgNo')}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 px-12 py-5 rounded-full border border-lavender/50 text-lavender transition-colors duration-300 hover:bg-lavender hover:text-white"
              data-testid="rsvp-no-button"
            >
              <X className="w-5 h-5" />
              <span className="font-display text-sm uppercase tracking-[0.25em]">{t('rsvp.no')}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RsvpSection;
